import Box from "@mui/material/Box";
import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import { CSSProperties, useContext, useMemo } from "react";
import DashboardPageContext from "../DashboardPageContext";
import DashboardEnvContext from "../DashboardEnvContext";
import PagetActionsContext from "../PagetActionsContext";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dashboard = useContext(DashboardEnvContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const pageContext = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const pageActions = useContext(PagetActionsContext);

	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties) {
			if (component.properties["width"]) style.width = component.properties["width"];
			if (component.properties["height"]) style.height = component.properties["height"];
			if (component.properties["padding"]) style.padding = component.properties["padding"];
			if (component.properties["backgroundColor"]) style.backgroundColor = component.properties["backgroundColor"];
			if (component.properties["flex"]) style.flex = component.properties["flex"];
			if (component.properties["flexBox"] && component.properties["flexBox"] === "True") style.display = "flex";
			if (component.properties["submitAction"]) style.cursor = "pointer";
		}
		return style;
	}, [component, exeMode]);
	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (component.properties["submitAction"]) {
			args["onClick"] = async () => {
				let actionPayload = undefined as unknown;
				if (component.properties["submitAction_Payload"]) {
					actionPayload = evaluteScript("const payload = " + component.properties["submitAction_Payload"] + "; payload");
				}
				if (dashboard) {
					pageActions.executePageAction(component.properties["submitAction"], {
						row: undefined,
						actionPayload: actionPayload,
					});
				}
			};
		}
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context, exeMode]);
	const componentStyles = useMemo(() => {
		try {
			if (component.styles) {
				const styles = typeof component.styles === "string" ? evaluteScript(component.styles) : component.styles;
				if (styles != undefined) return styles as CSSProperties;
			}
		} catch (error) {
			console.error(error);
		}
		return {} as CSSProperties;
	}, [component]);
	return (
		<Box key={component.id} sx={component.styles ? { ...style, ...componentStyles } : style} {...args}>
			{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}
		</Box>
	);
}

export default Component;
